import { render } from "./SalesReceipt.vue?vue&type=template&id=bda3a766&scoped=true&ts=true"
import script from "./SalesReceipt.vue?vue&type=script&lang=ts"
export * from "./SalesReceipt.vue?vue&type=script&lang=ts"

import "./SalesReceipt.vue?vue&type=style&index=0&id=bda3a766&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bda3a766"]])

export default __exports__